export default "__VITE_ASSET__b5bc8d94__"